// removed by extract-text-webpack-plugin
module.exports = {"progress":"_1kOpBUUV2D8wA4YJ3YboFH","loader":"_18HEZIsNuGj30uVTpdDlsi","bg":"VVK8nDeRtb6jMBkshZ89z","animate":"_3Dx8kZwe_kwUNV5rVQUczT","spin":"_2p_suTk38Ovhq1_3dkbh-n"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/LoaderRounded/style.css
// module id = 524
// module chunks = 38